import { defineFetchForNamespace } from '../../redux/fetch';

import { fetchCustomer } from '../service';
import { Customer } from '@pegasus/types/auth';
import { combineReducers } from 'redux';

export const NAME = 'fetch';
export const NAMESPACE = 'customer';

const { reducer, getIsInitial, getIsLoading, getData, fetchData } = defineFetchForNamespace<
    Customer,
    void,
    typeof NAMESPACE,
    typeof NAME
>(NAMESPACE, NAME, () => fetchCustomer().then(response => response.results));

const getCustomerInfoReducer = () => ({
    [NAMESPACE]: combineReducers({
        [NAME]: reducer,
    }),
});

export {
    getCustomerInfoReducer,
    getIsInitial,
    getIsLoading,
    getData as getCustomer,
    fetchData as fetchCustomer,
};
